export default __webpack_public_path__ + "static/img/app_google_play.31f504a.svg";